import React, { useEffect, useRef, useState } from 'react';
import { Tabs, Tab, Box, Typography, Grid, List, Button, TextField, IconButton, lighten, darken, FormHelperText } from '@mui/material';
import {Accordion, AccordionSummary, AccordionDetails, Chip, Tooltip, Paper, Stack, Alert, Zoom } from '@mui/material'
import { TabData } from './InterfaceInfo';
import { useNetwork, updateSelectedSection, useSection, useStoredLocationData, useStoredLocationParams, copyParams, useInputParams, useAllTags, useSearchText, useSearchMap, useIsSearchActive, updateSearch, clearSearch, setSearchText, useParamFilterState, useStoredParameters, useResponseSchema, deletePermenantLocData, deleteAllPermenantLocData } from '../state/services';
import { Recommendations } from '../api-request/api-request';
import { useInputParamState } from '../state/Input-param-state';
import { ConfirmationAlert, DisplayDialog } from '../pages/home/right-screen/RightPanelTab';
import {QueryStats, ExpandMore, RailwayAlert, TaskAlt, UnpublishedOutlined, ContentCopy, Close, KeyboardDoubleArrowDown, RemoveCircleOutlineOutlined} from '@mui/icons-material';
import {Dialog, DialogActions, DialogContent, DialogTitle, Slide} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { DialogContentText } from '@mui/material';
import { findCoordDetails, TagDialogDetails } from '../pages/home/heat-map/HeatMap';
import Select, { MultiValue } from "react-select";
import{ Bookmark, BookmarkBorder, Search} from '@mui/icons-material';
import ReusableDialog from './Dialog';
import { FixedSizeList, FixedSizeList as FixedSizeListComponent } from "react-window";
import { DynamicInputParameters } from '../types/ApiData';
import { useCoordPassSet } from '../hooks/useCoordPassSet';
import { hasActiveFilter } from '../utils/filterUtils';
import { getNetworkName } from '../utils/utils';
import { useOktaAuth } from '@okta/okta-react';
import { useMode } from '../state/application-state-service';
import { OnlineSidePanel } from '../pages/online-maps/sidepanel/OnlineSidePanel';


interface TabPanelProps {
  value: number;
  index: number;
  children: React.ReactNode;
  [key: string]: any;
}

const tabData: TabData = JSON.parse(process.env.REACT_APP_TAB || '{}');

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function SidePanelTab({ menuIndex, setIsSidePanelVisible, isMobile = false }: { menuIndex: number, setIsSidePanelVisible: (value:boolean) => void,  isMobile? : boolean }) {
  const [value, setValue] = useState(0);
  const mode = useMode()

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
      }}
    >
      <Tabs value={value} onChange={handleChange} aria-label="dynamic tabs example" variant="fullWidth" sx={{
        flexShrink: 0,
        borderBottom: 1,
        borderColor: 'divider',
        backgroundColor: 'grey.300',
        fontFamily: {
          'sans': ['Titillium Web', 'Roboto Mono', 'Helvetica', 'Arial', 'sans-serif'],
        },
      }}>
        {tabData.details_of_menus[menuIndex].left_screen.name_of_dashboards.map((tabName, key) => {
          return (
            <Tab sx={{
              textAlign: 'center',
              textTransform: 'none',
              backgroundColor: 'grey.200',
              '&:hover': {
                backgroundColor: 'grey.300',
              },
              minHeight: '40px',
              height: '50px',
              padding: '6px 12px',
              '& .MuiTab-iconWrapper': {
                marginLeft: '4px',
              },
              flexGrow: 1, // Allow the tab to grow
            }} label={tabName.name} key={key} iconPosition="end"
              icon={
                isMobile ? (
                  <IconButton onClick={() => setIsSidePanelVisible(false)}>
                    <KeyboardDoubleArrowDown color="primary" />
                  </IconButton>
                ) : undefined
              } />
          )
        })}
      </Tabs>

      {tabData.details_of_menus[menuIndex].left_screen.name_of_dashboards.map((tabName, key) =>
        key === 0 ? (
            <TabPanel value={value} index={key} key={key}>
            {mode === 'offline' ? <DisplaySections /> : <OnlineSidePanel/>}
          </TabPanel>
        ) : (
          <TabPanel value={value} index={key} key={key}>
            {mode === 'offline' ? <DisplaySections /> : <OnlineSidePanel/>}
          </TabPanel>
        )
      )}
    </Box>
  );
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export function AlertDialogSlide({ open, setOpen, data }: { open: boolean, setOpen: (value: boolean) => void, data: Recommendations[] | undefined }) {
  const [expanded, setExpanded] = useState<number | null>(null);

  const handleChangePanel = (index: number) => {
    setExpanded((prev) => (prev === index ? null : index)); // Toggle logic
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {setExpanded(null);setOpen(false)}}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"See Recommendations"}</DialogTitle>
        <DialogContent>
          {data && data.length > 0 &&
            (data).map((item, key) => {
              const color_code = item.color_code.startsWith("#")
                ? item.color_code
                : `#${item.color_code}`;
              return(
              <Accordion key={key} disableGutters  expanded={expanded === key} onChange={() => handleChangePanel(key)} >
                <AccordionSummary
                    expandIcon={<ExpandMore/>}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                  <Typography
                    component="span"
                    sx={{ width: "100%", color: color_code }}
                  >
                    {(item.success === true || Number(item.success) === 1)? <TaskAlt sx={{ marginRight: 2.5 }} fontSize='small' /> : <UnpublishedOutlined sx={{ marginRight: 2.5 }} fontSize='small' />}
                    {item.label}
                  </Typography>
                   <Chip label={item.level} sx={{ borderColor: color_code, color: color_code }} size='small' variant="outlined" />

                </AccordionSummary>
                <AccordionDetails>
                  <Paper elevation={0} sx={{ p: 2 }}>
                    <Grid container spacing={2} alignItems="stretch">
                        <Grid  key={key} container direction="column" spacing={1}>
                          <Stack sx={{ width: '100%' }} spacing={2}>
                          <Zoom
                                key={key}
                                in={expanded === key}
                                style={{ transitionDelay: expanded === key ? '100ms' : '0ms' }}
                                //style={{ transformOrigin: '0 0 0' }}
                                {...(expanded === key ? { timeout: 1000 } : {})}
                          >
                            <Alert
                              key={key}
                              sx={{
                                backgroundColor: lighten(color_code, 0.9),
                                color: darken(color_code, 0.1),
                              }}
                              icon={<RailwayAlert sx={{ color: color_code }} fontSize="inherit" />}
                            >
                             <Typography > {capitalizeWords(item.message)}</Typography>
                                <Box mt={1} p={1} borderRadius={1} >
                                  <Chip
                                    variant="outlined"
                                    label={`BSM ${item.bsm} ${item.unit}`}
                                    sx={{ mr: 1, fontWeight: "bold", borderColor: darken(color_code, 0.1), color: darken(color_code, 0.1) }}
                                  />
                                </Box>
                            </Alert>
                            </Zoom>
                          </Stack>
                        </Grid>
                    </Grid>
                  </Paper>
                </AccordionDetails>
            </Accordion>
            )})}
        </DialogContent>
        <DialogActions sx={{ flexDirection: 'column', alignItems: 'stretch' }}>
          <FormHelperText sx={{ color: 'green', mb: 1 }}>
            **Note - If none of the suggested recommendations work, the rails should be cut to prevent track buckling.
          </FormHelperText>

          <Button
            color="error"
            sx={{ alignSelf: 'flex-end' }}
            onClick={() => {
              setExpanded(null);
              setOpen(false);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

const capitalizeWords = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

const DisplaySections = () => {
  const network = useNetwork()
  const sections = network.edgesOfNetwork
  const selectedSection = useSection() || ''
  const paramState = useInputParamState()
  const locationData = useStoredLocationData()
  const storedInputParams = useInputParams()
  const allTags = useAllTags()
  const searchText = useSearchText()
  const searchMap = useSearchMap()
  const isSearchActive = useIsSearchActive()
  const paramFilter = useParamFilterState()
  const storedLocationParams = useStoredLocationParams()
  const savedGlobalParams = useStoredParameters() as DynamicInputParameters[]
  const { coordPassSet } = useCoordPassSet({
    network,
    savedGlobalParams,
    storedLocationParams,
    paramFilter,
    networkId: network.id ?? ''
  });
  const responseSchema = useResponseSchema()
  const { authState } = useOktaAuth();
  const accessToken = authState?.accessToken?.accessToken || '';

  const [formOpen, setFormOpen] = useState(false) // Display the result
  const [expanded, setExpanded] = useState<number | null>(null);
  const [selectedCoordResult, setSelecteCoordResult] = useState<Array<{
    key: string;
    label: string;
    unit?: string;
    type?: number;
    options?: { label: string; value: string }[];
    displayValue: any;
  }>>([])
  const [copy, setCopy] = useState(false)
  const [copyParamCoord, setCopyParamCoord] = useState<{source_coord: string, source_name: string}>({source_coord: '', source_name: ''})
  const [tagsPopupOpen, setTagsPopupOpen] = useState(false)
  const [sectionDetails, setSectionDetails]   = useState<{[key: string] : any}>({})

  const listRefs = useRef<Record<string, InstanceType<typeof FixedSizeListComponent> | null>>({});
  const accordionRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const [deleteCalc, setDeleteCalc] = useState<{isDelete : boolean, locParams: any, network_id: string, section_id: string}>({isDelete: false, locParams: '', network_id: '', section_id: ''})
  const [deleteAll, setDeleteAll] = useState(false) // delete object

  const handleDeleteCalculations = () => {
      deletePermenantLocData(paramState,accessToken, deleteCalc.locParams, deleteCalc.network_id, deleteCalc.section_id)
      setDeleteCalc({isDelete: false, locParams: '', network_id: '', section_id: ''})
  }

  const deleteAllCalculations = () => {
    const network_name = getNetworkName(network.id)
    deleteAllPermenantLocData(paramState, network_name, accessToken)
    setDeleteAll(false)
  }

  const handleOpen = () => setFormOpen(true);
  const handleClose = () => setFormOpen(false);

  const displayResponse = (value: any) => {
    const result = (() => {
      // Map for fast lookup
      const schemaMap = new Map(responseSchema.map(s => [s.code, s]));
      return Object.entries(value)
        .filter(([key]) => schemaMap.has(key))
        .map(([key, value]) => {
          const schema = schemaMap.get(key)!;

          return {
            key: key,
            code: schema.code,
            label: schema.label,
            hint: schema.hint,
            unit: schema.unit,
            value: value,
            displayValue: value,
          };
        });
    })();
    setSelecteCoordResult(result)
    handleOpen()
  }


  const selectSection = (id: string, key: number, edgeName: string, index?: number) => {
    let selected: any = { railwayEdgeId: id, coordinates: [], edgeName: edgeName, index: index ?? 0 }
    if (key === expanded) {
      selected = []
    }
    updateSelectedSection(paramState, selected)
  }

  const handleTagDialogOpen = (id: string, name: string) => {
      setSectionDetails({edgeId: id, edgeName: name})
      setTagsPopupOpen(true)
  }

  const handleCoordinateClick = (lat: number, long: number, name: string, index?: number) => {
    let values = { ...selectedSection, coordinates: [{ lat, long }], edgeName: name, index: index ?? 0 }
    updateSelectedSection(paramState, values)
  }

  const handleAccordionChange = (index: number) => {
    setExpanded(expanded === index ? null : index); // Toggle the accordion state
  };

  const handleOpenCopy = (coord: string, source_name: string) => {
    setCopyParamCoord({source_coord: coord, source_name: source_name})
    setCopy(true)
  }

  const handleCloseCopy = () => {
    setCopy(false)
    setCopyParamCoord({source_coord: '', source_name: ''})
  }


 /* useEffect(() => {
    return () => {
      updateSelectedSection(paramState, [])
    };
  }, []) */

  const handleSearch = () => {
    if (!searchText.trim()) {
      updateSearch(paramState, {}, false)
      return;
    }

    const lower = searchText.toLowerCase();

    const map: Record<
      string,
      { edgeMatch: boolean; coordMatches: Set<string> }
    > = {};

    Object.values(allTags).forEach((point) => {
      const hasMatch = point.tags.some(tag =>
        tag.toLowerCase().includes(lower)
      );

      if (!hasMatch) return;

      if (!map[point.edgeId]) {
        map[point.edgeId] = {
          edgeMatch: false,
          coordMatches: new Set()
        };
      }

      if (point.lat === 0 && point.lng === 0) {
        map[point.edgeId].edgeMatch = true;
      } else {
        map[point.edgeId].coordMatches.add(
          `${point.lat}-${point.lng}`
        );
      }
    });

    updateSearch(paramState, map, true)
  };

useEffect(() => {
  if (!selectedSection.railwayEdgeId) return;

  const { railwayEdgeId, index = 0 } = selectedSection;

  const accordionEl = accordionRefs.current[railwayEdgeId];
  const listRef = listRefs.current[railwayEdgeId];

  //  First scroll the Accordion into view
  if (accordionEl) {
    accordionEl.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }

  // Slight delay ensures accordion expansion has rendered
  if (listRef) {
    requestAnimationFrame(() => {
      listRef.scrollToItem(index, "center");
    });
  }

}, [selectedSection]);

  useEffect(() => {
    clearSearch(paramState)

  }, [network])

  const handleClearSearch = () => {
    clearSearch(paramState)
    updateSelectedSection(paramState, [])
  }

  const hasNoResults =
  isSearchActive && Object.keys(searchMap).length === 0

  const network_name = network.id ? getNetworkName(network.id) : ''
  const hasLocationCalc =
    locationData && network_name
      ? Object.values(locationData).some(
        (value) => value?.network_id === network_name
      )
      : false;

  return <>
    {network.id && <List>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 1,
          mb: 2,
        }}
      >
        <TextField
          fullWidth
          size="small"
          placeholder="Search tag..."
          value={searchText}
          onChange={(e) => setSearchText(paramState, e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && searchText.trim()) {
              handleSearch();
            }
          }}
        />

        <Button
          disabled={!searchText.trim()}
          variant="outlined"
          endIcon={<Search />}
          sx={{ textTransform: "none" }}
          size="small"
          onClick={handleSearch}
        >
          Search
        </Button>

        <Button
          sx={{ textTransform: "none" }}
          variant="outlined"
          disabled={!searchText.trim()}
          color="error"
          size="small"
          onClick={handleClearSearch}
        >
          Clear
        </Button>
      </Box>
      {hasNoResults && (
        <Typography color="error" sx={{ mb: 2 }}>
          No tags found.
        </Typography>
      )}
      {hasLocationCalc && <div className='p-2'>
        <Button sx={{textTransform: 'none'}} onClick={() => setDeleteAll(true)} color='error' variant='outlined'  endIcon={<RemoveCircleOutlineOutlined />} >Reset Calculations</Button>
      </div>}
      {(network.id) && sections &&
        sections.filter(section => {
          if (!isSearchActive) return true;
          return !!searchMap[section.railwayEdgeId];
        }).map((section, key) => {
          const selected = section.railwayEdgeId === selectedSection.railwayEdgeId;
          //let isExpanded = expanded === key
          let pointIdEdge = `${section.railwayEdgeId}:0-0`
          const tags = allTags[pointIdEdge]?.tags ?? [];
          let isExpanded = selected

          const filteredPoints = section.lineString.coordinates
            .map((coord: any, originalIndex: number) => ({
              coord,
              originalIndex,
            }))
            .filter(({ coord }: any) => {
            const lat = coord[1];
            const lng = coord[0];

            // existing tag search
            if (isSearchActive) {
              const edgeSearch = searchMap[section.railwayEdgeId];
              if (!edgeSearch) return false;
              if (!edgeSearch.edgeMatch && !edgeSearch.coordMatches.has(`${lat}-${lng}`)) return false;
            }

            // param filter (groups)
            if (hasActiveFilter(paramFilter) && coordPassSet && !coordPassSet.has(`${lat},${lng}`)) {
              return false;
            }

            return true;
          });
          if (filteredPoints.length === 0) return null;

          const rowHeight = 40; // height of a single row
          const maxVisibleRows = 10; // max height before scrolling

          return (
            <Accordion ref={(el) => (accordionRefs.current[section.railwayEdgeId] = el)} key={key} disableGutters expanded={isExpanded} onChange={() => handleAccordionChange(key)}>
              <AccordionSummary
                expandIcon={<ExpandMore />}
                sx={{
                  bgcolor: selected
                    ? '#33ae3319'
                    : key % 2 === 0
                      ? '#fdfdfd'
                      : '#f4f4f4',
                  borderBottom: selected ? '1px solid #33ae33' : '1px solid #eeeeee',
                  ':hover': {
                    bgcolor: '#33ae3319',
                    borderBottom: '1px solid #33ae33',
                  },
                }}
                onClick={() => selectSection(section.railwayEdgeId, key, section.edgeName)}
              >
                <Grid container spacing={1}>
                  <Grid item xs={8}>
                    <Typography variant="caption">Track Section</Typography>

                    <Grid container alignItems="center" gap={1.5}>
                      <span style={{ color: "green" }}>
                        {section.railwayEdgeName} ({Math.round(section.length)}m)
                      </span>

                      <Tooltip title={tags.length > 0 ? `${tags[0].substring(0, 6)}...` : 'Add Tag'} placement="top">
                        {tags.length > 0 ?
                          <Bookmark
                            onClick={(e) => {
                              e.stopPropagation()
                              handleTagDialogOpen(section.railwayEdgeId, section.edgeName)
                            }
                            }
                            fontSize="small"
                            sx={{ cursor: "pointer", color: 'purple' }}
                          /> : <BookmarkBorder
                            onClick={(e) => {
                              e.stopPropagation()
                              handleTagDialogOpen(section.railwayEdgeId, section.edgeName)
                            }
                            }
                            fontSize="small"
                            sx={{ cursor: "pointer", color: 'black' }}
                          />
                        }
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                {isExpanded && (
                  <>
                    <FixedSizeList
                      ref={(el: any) => (listRefs.current[section.railwayEdgeId] = el)}
                      height={Math.min(filteredPoints.length * rowHeight, maxVisibleRows * rowHeight)}
                      itemCount={filteredPoints.length}
                      itemSize={rowHeight}
                      width="100%"
                    >
                      {({ index, style }: { index: any; style: any }) => {
                        const point = filteredPoints[index];
                        const item = point.coord;
                        const originalIndex = point.originalIndex;

                        const selectedCoord =
                          Array.isArray(selectedSection.coordinates) &&
                          selectedSection.coordinates[0]?.lat === item[1] &&
                          selectedSection.coordinates[0]?.long === item[0];

                        const pointId = `${section.railwayEdgeId}:${item[1]}-${item[0]}`;
                        const edgePointId = `${section.railwayEdgeId}:0-0`;
                        const tags =
                          allTags[pointId]?.tags ??
                          allTags[edgePointId]?.tags ??
                          [];

                        const locationKey = `${item[1]},${item[0]}`;

                        const hasLocationData =
                          typeof locationData[locationKey] === "object" &&
                          locationData[locationKey] !== null &&
                          Object.keys(locationData[locationKey] as object).length > 0;

                        const network_name = getNetworkName(network.id)
                        const section_id = `${section.railwayEdgeName}.${originalIndex}`

                        return (
                          <div
                            key={index}
                            style={{
                              ...style,
                              width: "100%",
                              boxSizing: "border-box",
                              overflow: "hidden",
                            }}
                          >
                            <Box
                              sx={{
                                px: 1,
                                py: 0.5,
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Grid
                                container
                                alignItems="center"
                                wrap="nowrap"
                                sx={{
                                  minWidth: 0,
                                  width: "100%",
                                }}
                              >
                                <Grid
                                  item
                                  sx={{
                                    flex: "1 1 0",
                                    minWidth: 0,
                                    overflow: "hidden",
                                  }}
                                >
                                  <Chip
                                    label={
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: { xs: 0.25, sm: 0.5 },
                                          minWidth: 0,
                                          maxWidth: "100%",
                                        }}
                                      >
                                        <Box
                                          component="span"
                                          sx={{
                                            minWidth: 0,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            display: "block",
                                          }}
                                        >
                                          {`${section.railwayEdgeName}.${originalIndex}`}
                                        </Box>

                                        {tags.length > 0 && (
                                          <Box
                                            sx={{
                                              display: "inline-flex",
                                              alignItems: "center",
                                              flexShrink: 0,
                                            }}
                                          >
                                            <Tooltip
                                              title={`${tags[0].substring(0, 6)}...`}
                                              placement="top"
                                            >
                                              <Bookmark
                                                sx={{
                                                  color: "purple",
                                                  fontSize: { xs: 16, sm: 18 },
                                                  ml: 0.25,
                                                }}
                                              />
                                            </Tooltip>
                                          </Box>
                                        )}
                                      </Box>
                                    }
                                    onClick={() =>
                                      handleCoordinateClick(
                                        item[1],
                                        item[0],
                                        section.railwayEdgeName,
                                        originalIndex
                                      )
                                    }
                                    sx={{
                                      maxWidth: "100%",
                                      color: "green",
                                      cursor: "pointer",
                                      backgroundColor: selectedCoord ? "#33ae3319" : "#fdfdfd",
                                      ":hover": {
                                        backgroundColor: "#33ae3319",
                                      },
                                      "& .MuiChip-label": {
                                        display: "flex",
                                        alignItems: "center",
                                        overflow: "hidden",
                                        px: { xs: 0.5, sm: 1 },
                                        py: 0,
                                        maxWidth: "100%",
                                      },
                                    }}
                                  />
                                </Grid>

                                {hasLocationData && (
                                  <Grid
                                    item
                                    sx={{
                                      flex: "0 0 auto",
                                      ml: 0.25,
                                    }}
                                  >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 0.5,
                                        }}
                                      >
                                        <Tooltip title="See Calculations" placement="top">
                                        <Button
                                          variant={selectedCoord ? "outlined" : "contained"}
                                          onClick={() =>
                                            displayResponse(
                                              locationData[`${item[1]},${item[0]}`]
                                            )
                                          }
                                          sx={{
                                            color: "black",
                                            backgroundColor: selectedCoord
                                              ? "#33ae3319"
                                              : "white",
                                          }}
                                        >
                                          <QueryStats fontSize="small" />
                                        </Button>
                                      </Tooltip>

                                        <Tooltip title="Copy Parameters" placement="top">
                                          <IconButton
                                            size="small"
                                            onClick={() => handleOpenCopy(locationKey, section_id)}
                                            sx={{
                                              width: 32,
                                              height: 32,
                                              color: selectedCoord ? "green" : "black",
                                              p: 0,
                                              "& .MuiSvgIcon-root": {
                                                fontSize: 18,
                                              },
                                            }}
                                          >
                                            <ContentCopy fontSize="small" />
                                          </IconButton>
                                        </Tooltip>

                                      <Tooltip title="Reset Calculation" placement="top">
                                        <IconButton
                                          size="small"
                                          onClick={() => setDeleteCalc({isDelete: true, locParams: locationKey, network_id: network_name, section_id: section_id})}
                                          sx={{
                                            width: 32,
                                            height: 32,
                                            color: selectedCoord ? "green" : "black",
                                            p: 0,
                                            "& .MuiSvgIcon-root": {
                                              fontSize: 18,
                                            },
                                          }}
                                        >
                                          <RemoveCircleOutlineOutlined color='error' fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                      </Box>
                                  </Grid>
                                )}
                              </Grid>
                            </Box>
                          </div>
                        );
                      }}
                    </FixedSizeList>
                  </>
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      {(Object.keys(storedInputParams).length > 0 && formOpen) && <ReusableDialog open={formOpen} cancelText='Close' title='Trackstability calculation Result: Section' content={<DisplayDialog data={selectedCoordResult} />} onCancel={() => handleClose()} />}
      {copy && <CopyDialog accessToken={accessToken} copyParam={copyParamCoord} open={copy} handleClose={handleCloseCopy} />}
      {tagsPopupOpen && selectedSection && <ReusableDialog open={tagsPopupOpen} title='Tag Details' cancelText='Close' content={<TagDialogDetails edgeId={sectionDetails?.edgeId} edgeName={sectionDetails?.edgeName} isGeoPoint={false} section={selectedSection} />} onCancel={() => setTagsPopupOpen(false)} />}
      {deleteCalc.isDelete && <ConfirmationAlert open={deleteCalc.isDelete} handleClose={() => setDeleteCalc({isDelete: false, locParams: '', network_id: '', section_id: ''})} handleSubmit={() => handleDeleteCalculations()}
      message='This action will clear this geo-point configuration calculations and reset with the global settings. This cannot be undone.'
      title='Are you sure you want to reset?'
      />}
      {deleteAll && <ConfirmationAlert open={deleteAll} handleClose={() => setDeleteAll(false)} handleSubmit={() => deleteAllCalculations()}
      message='This action will clear all geo-point configuration calculations and reset with the global settings. This cannot be undone.'
      title='Are you sure you want to reset?'
      />}
    </List>}
  </>
}

export function CopyDialog({ open, handleClose, copyParam, accessToken }: { open: boolean, handleClose: () => void, copyParam: {source_coord: string, source_name: string}, accessToken: string }) {
  const [expanded, setExpanded] = useState<number | null>(null);
  const [selectedValues, setSelectedValues] = useState<{ [key: string]: any[] }>({});

  const network = useNetwork()
  const sections = network.edgesOfNetwork
  const paramState = useInputParamState()
  const locations = useStoredLocationParams()
  const locationData = useStoredLocationData()

  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const handleChangePanel = (index: number) => {
    setExpanded((prev) => (prev === index ? null : index)); // Toggle logic
  };

  const getCoords = (id: string) => {
    if (sections && sections.length > 0) {
      let edge = sections.find((edge) => edge.railwayEdgeId === id);
      if (edge) {
        const updatedCoords = edge.lineString.coordinates.map((coord: any, index: number) => ({
          name: `${edge?.railwayEdgeName}.${index}`,
          coords: `${coord[1]},${coord[0]}`,
          id: `${edge?.railwayEdgeId}`,
        }));
        return updatedCoords
      }
    }
  };


  const copyData = () => {
    let parameters = {}
    let results = {}
    let coordDetails : {[key: string]: any}[] | [] = []
    let target_locations: any[] = []
    let network_name = network?.id ? getNetworkName(network.id) : ''
    if (locations[copyParam.source_coord] && Object.entries(selectedValues).length > 0 && locationData[copyParam.source_coord]) {

      Object.entries(selectedValues).map(([edgeId, values]) => (
        values.length > 0 && (values.map((item, index) => {
              parameters = {...parameters,[item.coords]:  {...locations[copyParam.source_coord],id: edgeId}}
              results = {...results,[item.coords]:  {...locationData[copyParam.source_coord],id: edgeId}}
              const [lat, long] = item.coords.split(',');
              let coord = findCoordDetails({coord : [parseFloat(lat), parseFloat(long)]}, sections)
              coordDetails = [...coordDetails, coord]
              target_locations = [...target_locations, {latitude: parseFloat(lat), longitude: parseFloat(long), altitude: 30, network_id: network_name, section_id: coord.name}]
        })
      )))
      copyParams(paramState, parameters, results, coordDetails, copyParam.source_name, target_locations, network_name, accessToken)
      setSelectedValues({})
      setExpanded(null);
      handleClose()
    }
  }

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={'paper'}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Please select the geolocation coordinate for copying the parameters
        {Object.keys(selectedValues).length > 0 && (
          <Paper elevation={1} sx={{ p: 2, margin: 1 }}>
            <Grid container spacing={1} alignItems="flex-start">
                  <Grid item marginBottom={2} xs={12}>
                    <h4 className="text-sm font-medium text-gray-700">All Selected Coordinates:</h4>
                  </Grid>
                  {Object.entries(selectedValues).map(([edgeId, values]) => (
                    values.length > 0 && (
                      <>
                        <div>
                          {values.map((item, index) => (
                            <Chip
                              key={`${edgeId}-${index}`}
                              label={item.name}
                              sx={{
                                color: 'green',
                                borderColor: 'black',
                                backgroundColor: 'white'
                              }}
                            />
                          ))}
                        </div>
                      </>
                    )))}
            </Grid>
          </Paper>
          )}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <List>
              {(network.id) && sections && sections.map((section, key) => {
                let isExpanded = expanded === key
                return (
                  <Accordion key={key} disableGutters expanded={isExpanded} onChange={() => handleChangePanel(key)}>
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      sx={{
                        bgcolor: isExpanded
                          ? '#33ae3319'
                          : key % 2 === 0
                            ? '#fdfdfd'
                            : '#f4f4f4',
                        borderBottom: isExpanded ? '1px solid #33ae33' : '1px solid #eeeeee',
                        ':hover': {
                          bgcolor: '#33ae3319',
                          borderBottom: '1px solid #33ae33',
                        },
                      }}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={8}>
                          <Typography variant="caption">Track Section</Typography>
                          <br />
                          <span style={{ color: 'green' }}>{section.railwayEdgeName}({Math.round(section.length)}m)</span>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Paper elevation={1} sx={{ p: 2, margin: 1 }}>
                        <Grid key={key} container alignItems="center" justifyContent="flex-start"  flexWrap="wrap">
                          {isExpanded && <MultiSelectDropdown key={`${key}-${key+1}`}
                            options={getCoords(section.railwayEdgeId) || []}
                            selectedOptions={selectedValues[section.railwayEdgeId] || []}
                            onChange={(selected) => {
                              setSelectedValues((prev) => {
                                const updatedValues = { ...prev };

                                // If selected is empty, remove the entry for the particular railwayEdgeId
                                if (!selected || selected.length === 0) {
                                  delete updatedValues[section.railwayEdgeId];
                                } else {
                                  // Otherwise, update the values for that particular railwayEdgeId
                                  updatedValues[section.railwayEdgeId] = selected;
                                }

                                return updatedValues;
                              });
                            }}
                          />}
                        </Grid>
                      </Paper>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </List>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant={'outlined'} color='error' endIcon={<Close />} onClick={(e) => { setSelectedValues({});setExpanded(null); handleClose() }}>Cancel</Button>
          <Button variant={'outlined'} color='success' disabled={Object.entries(selectedValues).length > 0? false: true } onClick={copyData} endIcon={<ContentCopy />}  >Copy</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

interface OptionType {
  name: string;
  coords: string;
  id: string;
}

interface MultiSelectDropdownProps {
  options: OptionType[];
  selectedOptions: OptionType[];
  onChange: (selected: OptionType[]) => void;
}

export const MultiSelectDropdown  = ({options, selectedOptions,onChange}: MultiSelectDropdownProps) => {
  const handleChange = (selected: MultiValue<OptionType>) => {onChange(selected as OptionType[]); };
  return (
    <div className="w-full max-w-md mt-2">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Select GeoLocation Coordinates
      </label>
      <Select
        isMulti
        options={options}
        value={selectedOptions}
        onChange={handleChange}
        getOptionLabel={(e) => e.name}
        getOptionValue={(e) => e.coords}
        className="w-full"
        classNamePrefix="select"
      />
    </div>
  );
};